import React, { useEffect, useRef, useState } from 'react';

function enabledFor(userId) {
  try { return localStorage.getItem('chio-messenger-notifications:' + userId) === '1'; } catch (_) { return false; }
}

export default function BrowserNotifications({ userId, threads, openChat }) {
  const available = typeof Notification !== 'undefined';
  const [enabled, setEnabled] = useState(() => enabledFor(userId));
  const [error, setError] = useState('');
  const baseline = useRef(null); const started = useRef(Date.now()); const notices = useRef(new Map());
  useEffect(() => {
    const active = notices.current;
    return () => { active.forEach(notice => notice.close()); active.clear(); };
  }, []);
  useEffect(() => {
    if (!(threads || []).length) return;
    const next = new Map((threads || []).map(chat => [String(chat.id), String(chat.lastMessage && chat.lastMessage.id || '')]));
    const previous = baseline.current; baseline.current = next;
    if (!previous || !available || !enabled || Notification.permission !== 'granted' || !document.hidden) return;
    for (const chat of threads || []) {
      const item = chat.lastMessage; const id = String(chat.id);
      const preferences = ((chat.participants || []).find(person => String(person.userId) === String(userId)) || {}).preferences || {};
      if (!item || !chat.unreadCount || String(item.authorUserId) === String(userId) || item.type === 'system') continue;
      if (previous.get(id) === String(item.id)) continue;
      if (!previous.has(id) && !(Date.parse(item.createdAt) > started.current)) continue;
      if (preferences.notificationMode === 'silent' || (preferences.isMuted && (!preferences.mutedUntil || Date.parse(preferences.mutedUntil) > Date.now()))) continue;
      if (preferences.notificationMode === 'mentions' && !(item.mentionedUserIds || []).some(value => String(value) === String(userId))) continue;
      try {
        // No names or message bodies on the operating-system lock screen.
        const notice = new Notification('Новое сообщение в мессенджере', { tag: 'chio-chat-' + id, body: 'Откройте мессенджер, чтобы прочитать.' });
        const old = notices.current.get(id); if (old) old.close();
        notices.current.set(id, notice);
        notice.onclick = () => { window.focus(); openChat(chat.id); notice.close(); };
        notice.onclose = () => { if (notices.current.get(id) === notice) notices.current.delete(id); };
        if (notices.current.size > 20) { const first = notices.current.entries().next().value; first[1].close(); notices.current.delete(first[0]); }
      } catch (_) { /* Some browsers grant permission but require a service worker. */ }
    }
  }, [threads, userId, available, enabled, openChat]);
  const toggle = async () => {
    setError(''); let next = !enabled;
    if (next) {
      try { next = await Notification.requestPermission() === 'granted'; }
      catch (_) { next = false; }
      if (!next) setError('Разрешите уведомления для этого сайта в настройках браузера.');
    }
    setEnabled(next);
    if (!next) { notices.current.forEach(notice => notice.close()); notices.current.clear(); }
    try { localStorage.setItem('chio-messenger-notifications:' + userId, next ? '1' : '0'); } catch (_) { /* Preference applies for this tab session. */ }
  };
  if (!available) return null;
  return <div className="mw-browser-notifications"><button onClick={toggle} aria-pressed={enabled}>{enabled ? 'Уведомления браузера включены' : 'Включить уведомления браузера'}</button>{error && <p role="status">{error}</p>}</div>;
}
